<script>
import Typeahead from "$lib/components/Typeahead.svelte";
import {DateInput} from "date-picker-svelte";
import {availableProjectLeaders} from "$lib/calls/customer";
import SuggestInput from "$lib/components/SuggestInput.svelte";
import {availableAssociates, currentCustomer} from "$lib/stores/customer";
import {Input, Label} from "flowbite-svelte";
import {ClipboardListSolid, GridSolid, UserSolid} from "flowbite-svelte-icons";
import {afterUpdate, beforeUpdate} from "svelte";

export let project;

let customer;
currentCustomer.subscribe(async x => {
    customer = x
    availableAssociates.set(await availableProjectLeaders());
});
let associates;
let loading = true;
availableAssociates.subscribe(people => {
    if(people){
        associates = people
        loading = false;
    }
})

$: {
    beforeUpdate(() => {
        if(project.startsAt.getTime() - project.endsAt.getTime() > 0){
            project.endsAt = project.startsAt;
        }
    });
}

</script>

{#if loading}
    Loading...
{:else}
    <h3 class="text-2xl  leading-7 text-neutral-600 mb-3 mt-4">Allgemeine Informationen</h3>
    <Label class="space-y-2 mb-3">
        <span>Projektname</span>
        <Input required bind:value={project.name}>
            <GridSolid slot="left" class="text-primary-400"/>
        </Input>

    </Label>

    <div class="grid gap-3 grid-cols-2 ">
        <Typeahead icon={UserSolid} value={associates.find(x => x.id === project.responsibleAssociateId)?.name} label="Ansprechpartner Projekt" data={associates} extract={selected => project.responsibleAssociateId = selected.id}  let:value>
            <svelte:fragment slot="no-results">
                No results found for "{value}"
            </svelte:fragment>
        </Typeahead>
        <SuggestInput key="department" icon={ClipboardListSolid} label="Abteilung / Kostenstelle" bind:value={project.store[project.store.findIndex(x => x.identityKey==='department')].value}/>

    </div>
    <div class="grid gap-3 grid-cols-2">
        <Label class="space-y-2">
            <span>Beginn der Veranstaltung</span>
            <DateInput format="dd.MM.yyyy" closeOnSelection={true} browseWithoutSelecting={true} min={new Date()} bind:value={project.startsAt}/>
        </Label>
        <Label class="space-y-2">
            <span>Ende der Veranstaltung</span>
            <DateInput format="dd.MM.yyyy" closeOnSelection={true} browseWithoutSelecting={true} min={project.startsAt} bind:value={project.endsAt}/>
        </Label>

    </div>

    {#if project.startsAt !== project.endsAt}
        <div class="grid gap-3 grid-cols-2 mt-3">
            <div class="relative flex items-start py-4">
                <div class="min-w-0 flex-1">
                    <label for="separate" class="">In ein Projekt pro Tag aufteilen?</label>
                </div>
                <div class="ml-3 flex h-6 items-center">
                    <input id="separate" name="person-1" type="checkbox" class="h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-primary-600">
                </div>
            </div>
        </div>

    {/if}



{/if}